var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCompanyLogo = function SvgCompanyLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 143 144"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#company-logo_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 143,
    height: 143,
    y: 0.5,
    fill: "#F2F2F6",
    rx: 71.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A3A9BF",
    d: "M19.18 32.33h-1.297c-.716 0-1.297.58-1.297 1.297v9.08c0 .717.58 1.297 1.297 1.297h1.297c.717 0 1.298-.58 1.298-1.297v-9.08c0-.717-.581-1.297-1.298-1.297M24.629 27.66H23.33c-.716 0-1.297.58-1.297 1.297v9.08c0 .717.581 1.298 1.297 1.298h1.298c.716 0 1.297-.58 1.297-1.297v-9.08c0-.717-.58-1.298-1.297-1.298"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A0A6BD",
    fillRule: "evenodd",
    d: "M10.1 44.227 50.703 22.34V143.5H10.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4B5480",
    d: "M75.739 22.34H50.703V143.5h25.036z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#434E7F",
    fillRule: "evenodd",
    d: "M29.688 127.802h1.557a3.89 3.89 0 0 1 3.891 3.892v11.805h-9.34v-11.805a3.89 3.89 0 0 1 3.892-3.892",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#26326B",
    d: "M19.44 52.825h-3.113a3.113 3.113 0 0 0-3.114 3.113v4.67a3.113 3.113 0 0 0 3.114 3.114h3.113a3.113 3.113 0 0 0 3.113-3.114v-4.67a3.113 3.113 0 0 0-3.113-3.113"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFE0E9",
    d: "M19.44 90.315h-3.113a3.113 3.113 0 0 0-3.114 3.113v4.67a3.113 3.113 0 0 0 3.114 3.113h3.113a3.113 3.113 0 0 0 3.113-3.113v-4.67a3.113 3.113 0 0 0-3.113-3.114"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#434E7F",
    d: "M19.44 71.634h-3.113a3.113 3.113 0 0 0-3.114 3.113v4.67a3.113 3.113 0 0 0 3.114 3.113h3.113a3.113 3.113 0 0 0 3.113-3.113v-4.67a3.113 3.113 0 0 0-3.113-3.113M32.023 52.825H28.91a3.113 3.113 0 0 0-3.114 3.113v4.67a3.113 3.113 0 0 0 3.114 3.114h3.113a3.113 3.113 0 0 0 3.113-3.114v-4.67a3.113 3.113 0 0 0-3.113-3.113M32.023 90.315H28.91a3.113 3.113 0 0 0-3.114 3.113v4.67a3.113 3.113 0 0 0 3.114 3.113h3.113a3.113 3.113 0 0 0 3.113-3.113v-4.67a3.113 3.113 0 0 0-3.113-3.114M32.023 71.634H28.91a3.113 3.113 0 0 0-3.114 3.113v4.67a3.113 3.113 0 0 0 3.114 3.113h3.113a3.113 3.113 0 0 0 3.113-3.113v-4.67a3.113 3.113 0 0 0-3.113-3.113"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFE0E9",
    d: "M44.476 52.825h-3.113a3.113 3.113 0 0 0-3.114 3.113v4.67a3.113 3.113 0 0 0 3.114 3.114h3.113a3.113 3.113 0 0 0 3.114-3.114v-4.67a3.113 3.113 0 0 0-3.114-3.113"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#434E7F",
    d: "M44.476 90.315h-3.113a3.113 3.113 0 0 0-3.114 3.113v4.67a3.113 3.113 0 0 0 3.114 3.113h3.113a3.113 3.113 0 0 0 3.114-3.113v-4.67a3.113 3.113 0 0 0-3.114-3.114M44.476 71.634h-3.113a3.113 3.113 0 0 0-3.114 3.113v4.67a3.113 3.113 0 0 0 3.114 3.113h3.113a3.113 3.113 0 0 0 3.114-3.113v-4.67a3.113 3.113 0 0 0-3.114-3.113"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#26326B",
    d: "M67.437 52.825h-8.302a3.63 3.63 0 0 0-3.632 3.632v3.633a3.63 3.63 0 0 0 3.632 3.632h8.302a3.63 3.63 0 0 0 3.632-3.632v-3.633a3.63 3.63 0 0 0-3.632-3.632M67.437 90.315h-8.302a3.63 3.63 0 0 0-3.632 3.632v3.632a3.63 3.63 0 0 0 3.632 3.632h8.302a3.63 3.63 0 0 0 3.632-3.632v-3.632a3.63 3.63 0 0 0-3.632-3.633M67.437 30.253h-8.302a3.63 3.63 0 0 0-3.632 3.632v7.524a3.63 3.63 0 0 0 3.632 3.632h8.302a3.63 3.63 0 0 0 3.632-3.632v-7.524a3.63 3.63 0 0 0-3.632-3.632M67.437 71.634h-8.302a3.63 3.63 0 0 0-3.632 3.632v3.632a3.63 3.63 0 0 0 3.632 3.632h8.302a3.63 3.63 0 0 0 3.632-3.632v-3.632a3.63 3.63 0 0 0-3.632-3.632"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#434E7F",
    d: "M19.44 109.123h-3.113a3.113 3.113 0 0 0-3.114 3.113v4.67a3.114 3.114 0 0 0 3.114 3.114h3.113a3.113 3.113 0 0 0 3.113-3.114v-4.67a3.113 3.113 0 0 0-3.113-3.113M19.44 127.933h-3.113a3.113 3.113 0 0 0-3.114 3.113v4.67a3.114 3.114 0 0 0 3.114 3.114h3.113a3.113 3.113 0 0 0 3.113-3.114v-4.67a3.113 3.113 0 0 0-3.113-3.113M32.023 109.123H28.91a3.113 3.113 0 0 0-3.114 3.113v4.67a3.113 3.113 0 0 0 3.114 3.114h3.113a3.114 3.114 0 0 0 3.113-3.114v-4.67a3.113 3.113 0 0 0-3.113-3.113"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#26326B",
    d: "M44.476 109.123h-3.113a3.113 3.113 0 0 0-3.114 3.113v4.67a3.114 3.114 0 0 0 3.114 3.114h3.113a3.114 3.114 0 0 0 3.114-3.114v-4.67a3.113 3.113 0 0 0-3.114-3.113"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#434E7F",
    d: "M44.476 127.933h-3.113a3.113 3.113 0 0 0-3.114 3.113v4.67a3.114 3.114 0 0 0 3.114 3.114h3.113a3.114 3.114 0 0 0 3.114-3.114v-4.67a3.113 3.113 0 0 0-3.114-3.113"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#26326B",
    d: "M67.437 109.123h-8.302a3.63 3.63 0 0 0-3.632 3.632v3.632a3.633 3.633 0 0 0 3.632 3.633h8.302a3.633 3.633 0 0 0 3.632-3.633v-3.632a3.63 3.63 0 0 0-3.632-3.632M67.437 127.933h-8.302a3.63 3.63 0 0 0-3.632 3.632v3.633a3.63 3.63 0 0 0 3.632 3.632h8.302a3.63 3.63 0 0 0 3.632-3.632v-3.633a3.63 3.63 0 0 0-3.632-3.632"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A0A6BD",
    d: "M108.736 105.538H63.158v37.96h45.578z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4B5480",
    d: "M130.739 105.538h-22.003v37.96h22.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#434E7F",
    d: "M90.662 128.353h-9.43v15.145h9.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CDD0DC",
    d: "M77.303 128.157h-9.43v9.441h9.43zM77.303 112.225h-9.43v9.441h9.43zM104.021 128.157h-9.43v9.441h9.43zM104.021 112.225h-9.43v9.441h9.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFE0E9",
    d: "M90.662 112.225h-9.43v9.441h9.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A3A9BF",
    d: "M124.452 112.225h-9.43v9.441h9.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC1CF",
    d: "M124.452 128.157h-9.43v9.441h9.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CDD0DC",
    d: "M88.418 95.704h-4.942a2.244 2.244 0 0 0-2.244 2.244v4.953a2.243 2.243 0 0 0 2.244 2.244h4.942a2.243 2.243 0 0 0 2.244-2.244v-4.953a2.244 2.244 0 0 0-2.244-2.244"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4B5480",
    d: "M116.201 86.065H84.768v19.669h31.433z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A0A6BD",
    d: "M94.591 86.065H63.158v19.669h31.433z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CDD0DC",
    d: "M77.303 88.623h-9.43v14.358h9.43zM90.662 88.623h-9.43v14.358h9.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A3A9BF",
    d: "M117.969 82.919H94.591v3.146h23.378z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CDD0DC",
    d: "M111.486 102.587H94.591v3.147h16.895z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A3A9BF",
    d: "M132.9 102.587h-21.414v3.147H132.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CDD0DC",
    d: "M96.752 82.919H63.158v3.146h33.594z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 142,
    height: 142,
    x: 0.5,
    y: 1,
    stroke: "#8389A9",
    rx: 71
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "company-logo_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 143,
    height: 143,
    y: 0.5,
    fill: "#fff",
    rx: 71.5
  })))));
};
export default SvgCompanyLogo;